export default "__VITE_ASSET__9Jnx2j1B__"